import styled from "styled-components";
import { colors } from "../../styled/varibles";

export const HeaderContainerSC = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 0 3rem;
    background: ${colors.bgMenu};
    border: 1px solid ${colors.stroke};
`;
export const TitleSC = styled.div`
    font-family: "Inter";
    font-style: normal;
    font-weight: 700;
    font-size: 2.4rem;
    line-height: 160%;
    letter-spacing: -0.01em;
    color: ${colors.textColor};
    width: 35.2rem;
`;

export const ContentSC = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 2.4rem 0px 2.5rem;
    width: 100%;
    flex: 1;
    justify-content: space-between;
`;

export const ProjectNameSC = styled.h3`
    font-family: "Inter";
    font-style: normal;
    font-weight: 600;
    font-size: 2rem;
    line-height: 160%;
    letter-spacing: -0.01em;
    color: ${colors.lightTextColor};
    margin: 0;
`;
